export default "__VITE_ASSET__aeb5ce24__"